/**
 * 이메일 형식 여부를 검사하는 함수
 * @param {string} value - 검사할 이메일 문자열
 * @returns {boolean} 이메일 형식이면 true, 아니면 false
 */
export const isEmail = (value) => {
    if (typeof value !== "string") return false;
    const mail = value.trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail);
}

/**
 * decodeURIComponent 안전 처리 함수
 * - 디코딩 실패 시 원본 문자열 반환
 * @param {*} value - 디코딩할 값
 * @returns {string} 디코딩된 문자열 또는 원본 문자열
 */
export const safeDecode = (value) => {
    const string = String(value);
    try {
        return decodeURIComponent(string);
    } catch {
        return string;
    }
};

/**
 * RTK Query 태그 무효화 후 재호출 처리 함수
 * @param {Function} dispatch - Redux dispatch 함수
 * @param {*} api - RTK Query api 객체
 * @param {string} tags - invalidate 할 태그명
 */
export const getReFetch = (dispatch, api, tags) => {
    dispatch(api.util.invalidateTags([`${tags}`]));
};

/**
 * Vimeo URL을 embed URL 형태로 변환하는 함수
 * @param {string} url - Vimeo URL
 * @returns {string} Vimeo embed URL
 */
export const convertVimeo = (url) => {
    if (!url) return "";

    if (url.includes("player.vimeo.com")) return url;

    const id = getVimeoId(url);

    return `https://player.vimeo.com/video/${id}?background=1&autoplay=1&muted=1&loop=1&controls=0`;
}

/**
 * Vimeo URL에서 영상 ID를 추출하는 함수
 * @param {string} url - Vimeo URL
 * @returns {string} Vimeo 영상 ID
 */
export const getVimeoId = (url) => {
    if (!url) return "";
    const parts = url.split("/");
    return parts[parts.length - 1];
}

/**
 * Youtube URL에서 영상 ID를 추출하는 함수
 * @param {string} url - Youtube URL
 * @returns {string|null} Youtube 영상 ID
 */
export const getYoutubeId = (url) => {
    if (!url) return "";
    if (url.includes("youtu.be")) {
        return url.split("/").pop();
    }
    const params = new URL(url).searchParams;
    return params.get("v");
}

/**
 * Youtube URL을 embed URL 형태로 변환하는 함수
 * @param {string} url - Youtube URL
 * @returns {string} Youtube embed URL
 */
export const convertYoutube = (url) => {
    const id = getYoutubeId(url);
    if (!id) return "";

    return `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&rel=0&playsinline=1`;
}